import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "./BankAccountTransactions";

export class SetTransactionCounterpart {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], uuid:string|number, listFilters?): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
    }
    try {
      //this.frontend.loading_update_counterpart(true)
      await this.dispatcher.dispatch('set_transactions_counterpart', args)
      await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(uuid, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)
    } catch (error) {
      console.error('Error update transactions counterpart', error)
    }
    //this.frontend.loading_update_counterpart(false)
  }

  async run_async_job(transaction_ids:[string]): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
    }
    try {
      this.frontend.action = 'update_counterparts'
      let res = await this.dispatcher.dispatch('set_transactions_counterpart', args)
      this.frontend.asyncJobState = 'running';
      this.frontend.asyncJobId = res.job_id
    } catch (error) {
      console.error('Error update transactions counterpart', error)
    }
  }
}